import React from 'react';
import { Cascader, Form } from '@douyinfe/semi-ui';
import provinces from 'china-division/dist/provinces.json';
import cities from 'china-division/dist/cities.json';
import areas from 'china-division/dist/areas.json';

// 构建省市区数据
const buildRegionData = () => {
    // 构建区县数据
    const areaMap = {};
    areas.forEach(area => {
        const cityCode = area.cityCode;
        if (!areaMap[cityCode]) {
            areaMap[cityCode] = [];
        }
        areaMap[cityCode].push({
            label: area.name,
            value: area.name,
            code: area.code
        });
    });

    // 构建城市数据
    const cityMap = {};
    cities.forEach(city => {
        const provinceCode = city.provinceCode;
        if (!cityMap[provinceCode]) {
            cityMap[provinceCode] = [];
        }
        cityMap[provinceCode].push({
            label: city.name,
            value: city.name,
            code: city.code,
            children: areaMap[city.code] || []
        });
    });

    // 构建省份数据
    return provinces.map(province => ({
        label: province.name,
        value: province.name,
        code: province.code,
        children: cityMap[province.code] || []
    }));
};

// 中国省市区数据
const regionData = [
    ...buildRegionData()
];

const RegionSelector = ({ field, label, rules, initValue, onChange }) => {
    const handleChange = (value) => {
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <Form.Cascader
            field={field}
            label={label}
            rules={rules}
            initValue={initValue}
            treeData={regionData}
            placeholder="请选择省/市/区"
            onChange={handleChange}
            style={{ width: '100%' }}
        />
    );
};

export default RegionSelector;